import React, {Component} from 'react'
import PropTypes from 'prop-types'
import moment from "moment"
import {Tooltip, Icon} from 'antd'

class CreatedDate extends Component {
    _checkTypeDisplay = (types) => {
        const listTypes = ['POSTER', 'CANVAS', 'ORNAMENT_3D', 'PHONECASE_3D', 'MUG', 'YARD_SIGN', 'STICKER']
        const listPass = types.filter(item => {
            return listTypes.includes(item)
        })

        return listPass.length <= 0
    }

    _renderOvertime = () => {
        const {item, field} = this.props

        let fieldOvertime = ''

        switch (field) {
            case 'printing_at':
                fieldOvertime = 'printed_overtime'
                break
            case 'transferred_at':
                fieldOvertime = 'transferred_overtime'
                break
            case 'sewing_at':
                fieldOvertime = 'sewed_overtime'
                break
            default:
                break
        }

        if (item[fieldOvertime] > 0) {
            return this._checkTypeDisplay(item.product_types) ? true : (fieldOvertime !== 'transferred_overtime')
        }
        return false
    }

    _convertDateOverTime = (time) => {
        const intTime = time * 60 * 60
        const total_minutes = parseInt(Math.floor(intTime / 60))
        const total_hours = parseInt(Math.floor(total_minutes / 60))
        const days = parseInt(Math.floor(total_hours / 24)) !== 0 ? parseInt(Math.floor(total_hours / 24)) + 'd ' : ''

        const minutes = parseInt(total_minutes % 60) !== 0 ? parseInt(total_minutes % 60) + 'm ' : ''
        const hours = parseInt(total_hours % 24) !== 0 ? parseInt(total_hours % 24) + 'h ' : ''

        return days + hours + minutes
    }

    _showOvertime = (field) => {
        const {item} = this.props

        switch (field) {
            case 'printing_at':
                return this._convertDateOverTime(item['printed_overtime'])
            case 'transferred_at':
                return this._convertDateOverTime(item['transferred_overtime'])
            case 'sewing_at':
                return this._convertDateOverTime(item['sewed_overtime'])
            default:
                return false
        }
    }

    _displayDate = (item, field) => {
        const passType = this._checkTypeDisplay(item.product_types)

        if (passType) {
            return item[field] ? moment(item[field]).format('HH:mm DD/MM/YYYY') : '-'
        } else {
            if (field === 'sewing_at') {
                return item.printed_at ? moment(item.printed_at).format('HH:mm DD/MM/YYYY') : '-'
            }

            if (field !== 'transferred_at' && field !== 'sewing_at') {
                return item[field] ? moment(item[field]).format('HH:mm DD/MM/YYYY') : '-'
            } else {
                return '-'
            }
        }
    }

    render() {
        const {item, field} = this.props
        const textTime = this._displayDate(item, field)
        const isOvertime = field !== 'created_at' ? this._renderOvertime() : false

        let messTooltip = ''
        switch (field) {
            case 'printing_at':
                messTooltip = 'Quá hạn in'
                break
            case 'transferred_at':
                messTooltip = 'Quá hạn ép'
                break
            case 'sewing_at':
                messTooltip = 'Quá hạn may'
                break
            default:
                break
        }

        return (
            <td className="colDate">
                <div className="d-flex flex-column">
                    {textTime}
                    {
                        (isOvertime) &&
                        <span>
                            <Tooltip placement="top" title={messTooltip}>
                                <Icon className="text-danger mr-1" type="history"
                                      style={{fontSize: 16}}
                                /></Tooltip>
                            <span className="text-danger">
                                {
                                    this._showOvertime(field)
                                }
                            </span>
                        </span>
                    }
                </div>
            </td>
        )
    }
}

CreatedDate.propTypes = {
    item: PropTypes.object.isRequired,
    field: PropTypes.string.isRequired
}

export default CreatedDate
